var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShieldSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4543_13071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3304 8.66508C13.3304 11.9977 10.9976 13.664 8.22483 14.6305C8.07963 14.6797 7.92192 14.6773 7.77826 14.6238C4.99885 13.664 2.66602 11.9977 2.66602 8.66508V3.9994C2.66602 3.82263 2.73624 3.6531 2.86124 3.5281C2.98623 3.4031 3.15577 3.33288 3.33254 3.33288C4.66559 3.33288 6.3319 2.53305 7.49165 1.51993C7.63286 1.39929 7.81249 1.33301 7.99821 1.33301C8.18394 1.33301 8.36356 1.39929 8.50477 1.51993C9.67119 2.53972 11.3308 3.33288 12.6639 3.33288C12.8407 3.33288 13.0102 3.4031 13.1352 3.5281C13.2602 3.6531 13.3304 3.82263 13.3304 3.9994V8.66508Z",
    stroke: "#1956A8",
    strokeWidth: 1.33305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4543_13071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9966,
    height: 15.9966,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldSmall);
export default __webpack_public_path__ + "static/media/icon_shield_small.6018fb38950a25e89bfb691c74feb3b2.svg";
export { ForwardRef as ReactComponent };